import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Table, Drawer } from 'antd';
import { H3_TITLE } from '@Apis/constants';
import { Helmet } from 'react-helmet';
import TenantActions from '@Actions/tenantActions';
import UserActions from '@Actions/userActions';
import H3Text from '@Uilib/h3Text';
import {
  EditOutlined,
} from '@ant-design/icons';
import Helpers from '@Apis/helpers';
import './style.scss';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import CreateRole from '@Components/Settings/ManageTeam/Roles/CreateRole';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import UpdatePermissions from './UpdatePermissions';
import PRZText from '../../../Common/UI/PRZText';

class ManageRole extends Component {

  constructor(props) {
    super(props);
    this.state = {
      rolecolumns: [
        {
          title: '',
          render: (record) => {
            const { user } = this.props;
            const defaultTenantStoreId = user?.tenant_info?.default_store_id;
            return (
              <div className="mobile-list__card">
                <div className="mobile-list__card_body">
                  <div className="mobile-list__card_body-left" style={{width: '100%'}}>
                    <PRZText text={`DEPARTMENT - ${record?.tenant_department_info?.alias_name || '-'} ${(defaultTenantStoreId === record?.tenant_department_info?.tenant_department_id) ? '(Default)' : ''}`}className="mobile-list__card_item-details" />
                    <PRZText text={`ROLE - ${record.tenant_role_name || '-'}`}className="mobile-list__card_item-details" />
                  </div>
                </div>
              </div>
            )
          },
          responsive: ['xs'],
        },
        {
          title: 'DEPARTMENT',
          render: (text, record) => {
            const { user } = this.props;
            const defaultTenantStoreId = user?.tenant_info?.default_store_id;
            return (
              <div className="dept-name-wrapper">
                <H3Text text={record?.tenant_department_info?.alias_name || '-'} />
                {(defaultTenantStoreId === record?.tenant_department_info?.tenant_department_id) && <H3Text text="Default" className="default-dept" />}
              </div>
            );
          },
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'ROLE',
          render: (text, record) => (
            <H3Text text={record.tenant_role_name || '-'} />
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: '',
          render: (text, record) => {
            const { user } = this.props;
            return (
              <div className="list__actions">
                {Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                  Helpers.permissionTypes.UPDATE, user) && (
                    <div
                      className="roundIconButton"
                      onClick={() => {
                        this.setState({
                          showPermissions: true,
                          selectedPermissions: record,
                        });
                      }}
                    >
                      <EditOutlined />
                    </div>
                  )}
              </div>
            );
          },
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
      ],
      showNewRoleDrawer: false,
    };
  }

  /**
   *
   */
  componentDidMount() {
    const { user, getRoles } = this.props;
    getRoles(user?.tenant_info?.tenant_id);
  }

  render() {
    const {
      roles, getRolesLoading, getRoles, user,
    } = this.props;
    const {
      rolecolumns, showPermissions, selectedPermissions, showNewRoleDrawer,
    } = this.state;
    return (
      <Fragment>
        <Drawer
          placement="right"
          onClose={() => this.setState({ showPermissions: false })}
          open={showPermissions}
          width="700px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '655px' }}>
              <H3Text text="Update Role" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showPermissions: false })} />
            </div>
          </div>
          <UpdatePermissions
            selectedPermissions={selectedPermissions}
            callback={() => {
              getRoles(user?.tenant_info?.tenant_id);
              this.setState({ showPermissions: false });
            }}
            onClose={() => this.setState({ showPermissions: false })}
          />
        </Drawer>
        <Drawer
          placement="right"
          onClose={() => this.setState({ showNewRoleDrawer: false })}
          open={showNewRoleDrawer}
          width="700px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '655px' }}>
              <H3Text text="Create New Role" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showNewRoleDrawer: false })} />
            </div>
          </div>
          <CreateRole
            callback={() => {
              getRoles(user?.tenant_info?.tenant_id);
              this.setState({ showNewRoleDrawer: false });
            }}
            onClose={() => this.setState({ showNewRoleDrawer: false })}
          />
        </Drawer>
        <div className="doc-list__wrapper doc-list__tab-content">
          <div className="ant-row">
            <div className="ant-col-md-11 ant-col-xs-24">
              <div className="doc-list__table-wrapper show-table-header-in-mobile">
                <Table
                  title={() => (
                    <div className="doc-list__table-header">
                      <div className="doc-list__table-header__left">
                        {`${roles?.data?.length || '0'} Roles`}
                      </div>
                      <div className="doc-list__table-header__right">
                        {Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP, Helpers.permissionTypes.CREATE, user) && (
                          <div className="doc-list__buttons-wrapper">
                            <H3Button
                              buttonType={defaultButtonTypes.BLUE_ROUNDED}
                              text="+ New Role"
                              onClick={() => this.setState({ showNewRoleDrawer: true })}
                              customClass="add-button"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  showHeader
                  loading={getRolesLoading}
                  size="small"
                  columns={rolecolumns}
                  dataSource={roles?.data || []}
                  currentPage
                  pagination={roles?.data?.length > 10 ? {
                    defaultCurrent: 1,
                    pageSize: 10,
                    position: ['bottomRight'],
                    showSizeChanger: false,
                  } : false}
                  bordered
                />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, TenantReducers,
}) => ({
  user: UserReducers.user,
  users: TenantReducers.users,
  getUsersLoading: UserReducers.getUsersLoading,
  updateUserLoading: UserReducers.updateUserLoading,
  roles: UserReducers.roles,
  permissions: UserReducers.permissions,
  getRolesLoading: UserReducers.getRolesLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getUsers: (tenantId) => dispatch(TenantActions.getUsers(tenantId)),
  updateUser: (payload, callback) => dispatch(UserActions.updateUser(payload, callback)),
  getRoles: (page) => dispatch(UserActions.getRoles(page)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ManageRole));
